// extracted by mini-css-extract-plugin
module.exports = {"communicareZIndex":"MountCommunicare_communicareZIndex__2VIoD","fixed":"MountCommunicare_fixed__27rx5"};